<div id="ol-map" class="map-container"></div>
<div class="bottom-map">
  <app-scaleline [map]="map"></app-scaleline>
  <app-mouse-position [map]="map" positionTemplate="{x}, {y}"></app-mouse-position>
</div>